"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

var _semanticUiReact = require("semantic-ui-react");

var _Image = _interopRequireDefault(require("../../../atoms/Image"));

var _CloseIconDark = _interopRequireDefault(require("../assets/CloseIconDark.png"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var MessageDisplayBanner = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MessageDisplayBanner, _React$Component);

  var _super = _createSuper(MessageDisplayBanner);

  function MessageDisplayBanner() {
    (0, _classCallCheck2["default"])(this, MessageDisplayBanner);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(MessageDisplayBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          businessName = _this$props.businessName,
          open = _this$props.open,
          subject = _this$props.subject,
          content = _this$props.content,
          onClose = _this$props.onClose,
          extra = _this$props.extra;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal, {
        className: "fm-message-display-modal",
        open: open,
        onClose: onClose,
        dimmer: "inverted"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, null, /*#__PURE__*/_react["default"].createElement("div", null, "Message from", businessName), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        onClick: onClose
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: _CloseIconDark["default"],
        fluid: true
      }))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, {
        scrolling: true
      }, subject && /*#__PURE__*/_react["default"].createElement("h4", null, subject), content && /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], null, content), extra));
    }
  }]);
  return MessageDisplayBanner;
}(_react["default"].Component);

exports["default"] = MessageDisplayBanner;
MessageDisplayBanner.propTypes = {
  businessName: _propTypes["default"].string.isRequired,
  open: _propTypes["default"].string.isRequired,
  subject: _propTypes["default"].string.isRequired,
  content: _propTypes["default"].string,
  onClose: _propTypes["default"].func.isRequired
};
MessageDisplayBanner.defaultProps = {
  content: ''
};